import { render, staticRenderFns } from "./Physiology-List.vue?vue&type=template&id=1164bfea&"
import script from "./Physiology-List.js?vue&type=script&lang=js&"
export * from "./Physiology-List.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports